import { InMemoryCache } from '@apollo/client';
import { setOnboardingToken } from '@blocs.auth';
import { ProfileQueries } from '@minecraft.shared-queries';

const { IS_LOGGED_IN } = ProfileQueries;

export const initializeLogin = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: IS_LOGGED_IN,
    data: {
      token: null,
      isLoggedIn: false,
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      setUserToken: (_, args, { cache }): null => {
        if (args.token !== null) {
          setOnboardingToken(args.token);
        }

        cache.writeQuery({
          query: IS_LOGGED_IN,
          data: {
            __typename: 'token',
            token: args.token,
            isLoggedIn: args.isLoggedIn,
          },
        });

        return null;
      },
    },
  },
};
